var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('visitor')],1),_vm._v(" "),_c('main',{staticClass:"ui_index"},[_c('index',{attrs:{"freePlayBuutton":true}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c52bea00","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/visitor/freeTrial/GetStartedFreePlay.vue
// module id = null
// module chunks = 